import styled from '@emotion/styled';
import { switchProp } from 'styled-tools';
import { Text } from '~/shared/components/Text';
import { Line } from '~/shared/components/Line';
import { Link } from '~/shared/components/Link';

type StyledMenuProps = {
    level?: 'level0' | 'level1';
    current?: boolean;
};

export const StyledSubMenuTitle = styled(Text)(({ theme }) => ({
    lineHeight: theme.spaces[5],
}));

export const StyledSubMenuLink = styled(Link, {
    shouldForwardProp: (prop: string) => prop !== 'current',
})<StyledMenuProps>(
    ({ theme, current }) => ({
        fontWeight: current ? theme.text.weights.bold : theme.fontWeights.regular,
    }),
    switchProp('level', {
        level0: ({ theme }) => ({
            paddingTop: theme.spaces[2],
            marginBottom: theme.spaces[2],
            lineHeight: theme.spaces[6],
            float: 'left',
            clear: 'both',
            '&:not(:first-of-type)': {
                marginTop: theme.spaces[2],
            },
        }),
        level1: () => ({
            float: 'left',
            clear: 'both',
        }),
    })
);

export const StyledSubMenuLine = styled(Line)(({ theme }) => ({
    margin: `0 0 ${theme.spaces[2]} -${theme.spaces[3]}`,
    width: 'auto',
    clear: 'both',
}));

export const StyledSubmenusContainer = styled.div(({ theme }) => ({
    paddingLeft: theme.spaces[3],
}));

export const StyledMenusContainer = styled.div(({ theme }) => ({
    marginBottom: theme.spaces[2],
}));
